import React, { useState } from "react";
import { Link } from "react-router-dom";
import services from "../data/services";
import "./Services.css";

const Services = () => {
  const [expanded, setExpanded] = useState(null);

  return (
    <section className="services" aria-label="Unsere Reinigungsleistungen in Berlin und Umgebung">
      <h2>Unsere Leistungen in Berlin und Umgebung</h2>
      <div className="cards">
        {services.map((service, index) => (
          <article className="card" key={service.slug} itemScope itemType="https://schema.org/Service">
            <img
              src={service.img}
              alt={`${service.title} - Professionelle Gebäudereinigung in Berlin`}
              loading="lazy"
              width="400"
              height="300"
            />
            <h3 itemProp="name">{service.title}</h3>
            <ul>
              {service.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <button
              className="button"
              onClick={() => setExpanded(expanded === index ? null : index)}
            >
              {expanded === index ? "Weniger anzeigen" : "Kurzüberblick"}
            </button>
            {expanded === index && (
              <div className="details">
                <img
                  src={service.detailImg}
                  alt={`${service.title} - Detaillierte Ansicht der Reinigungsleistung`}
                  loading="lazy"
                  width="600"
                  height="400"
                />
                <p itemProp="description">{service.detailText}</p>
              </div>
            )}
            <Link className="service-more" to={`/leistungen/${service.slug}`}>
              Mehr zur {service.title}
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Services;
